<template>
  <el-tooltip effect="dark" placement="top">
    <template #content>
      <slot />
    </template>
    <font-awesome-icon icon="question-circle" />
  </el-tooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'IconWithHint'
})
</script>
